var render, staticRenderFns
import script from "./ConferenceUser.vue?vue&type=script&lang=js&"
export * from "./ConferenceUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279c9694')) {
      api.createRecord('279c9694', component.options)
    } else {
      api.reload('279c9694', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/Conference/resources/vue/ConferenceUser.vue"
export default component.exports